import React from 'react';
import { Alert, Button, CircularProgress } from '@mui/material';

export interface ChangeFocusOutsideFiltersBannerProps {
  label: string;
  onShowInList: () => void;
  loading?: boolean;
}

/** Banner plano B — norma do alerta oculta pelos filtros atuais da tabela. */
export function ChangeFocusOutsideFiltersBanner({
  label,
  onShowInList,
  loading = false,
}: ChangeFocusOutsideFiltersBannerProps) {
  return (
    <Alert
      severity="warning"
      sx={{ mb: 1.5 }}
      action={
        <Button
          color="inherit"
          size="small"
          onClick={onShowInList}
          disabled={loading}
          startIcon={loading ? <CircularProgress size={14} color="inherit" /> : undefined}
        >
          Mostrar na lista
        </Button>
      }
    >
      Norma fora dos filtros atuais — {label}
    </Alert>
  );
}
